<template>
<div>
  <v-dialog width="500" v-model="createDialog">
    <v-btn block color="primary" slot="activator">
      <v-icon>person_add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('user.create.title') }}
      </v-card-title>
      <create-form @exit="userCreated()"></create-form>
    </v-card>
  </v-dialog>
  <v-btn :to="{ name: 'departments'}">
    <v-icon>account_tree</v-icon>
  </v-btn>
  <v-btn :to="{ name: 'agencies'}">
    <v-icon>face</v-icon>
  </v-btn>
  <v-btn :to="{ name: 'rbac'}">
    <v-icon>settings</v-icon>
  </v-btn>
  <v-card-title>
    <v-spacer></v-spacer>
    <v-text-field v-model="search" append-icon="search" :label="`${$t('data-table.search')}`" single-line hide-details></v-text-field>
  </v-card-title>
  <v-data-table :headers="headers" :items="users" :loading="loading" :no-data-text="tableTranslations.noDataText" :rows-per-page-text="tableTranslations.rowsPerPageText"
                :search="search"
                class="elevation-1"
    :no-results-text="tableTranslations.noResultsText" :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination">
    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <td class="text-xs-right">{{ props.item.id }}</td>
      <td class="text-xs-left">{{ props.item.username }}</td>
      <td class="text-xs-left">{{ props.item.name }} {{ props.item.surname }}</td>
      <td class="text-xs-left">{{ props.item.phone }}</td>
      <td class="text-xs-left">{{ getTeamName(props.item.team_id) }}</td>
      <td class="text-xs-left">{{ roleObj.translateRole(props.item.role) }}</td>
      <td class="text-xs-left">{{ getAgencyName(props.item.agency_id) }}</td>
      <td class="text-xs-left">{{ props.item.email }}</td>
      <td class="text-xs-left">{{ props.item.created_at | timestampToDate }}</td>
      <td class="text-xs-left">
        <v-btn class="btn-user-action" block color="primary" :to="{ name: 'user-view', params: { idUser: props.item.id } }" slot="activator">
          <v-icon>mdi-account-edit</v-icon>
        </v-btn>
        <v-btn v-if="acl.isAdmin() && Settings.deleteUserEnable()" @click="deleteUser(props.item.id)" class="btn-user-action" block color="red">
          <v-icon>delete</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</div>
</template>

<script>
import CreateForm from "./dialogs/CreateForm"
import Acl from "@/plugins/Acl"
import Settings from "@/plugins/Settings"
import Messenger from "@/plugins/Messenger"
import Role from "../../plugins/Role"

export default {
  components: {
    CreateForm
  },
  data() {
    return {
      Settings,
      acl : new Acl(),
      pagination: this.$store.getters.pagination,
      agencies : [],
      search: "",
      createDialog: false,
      loading: true,
      roleObj: new Role(),
      headers: [{
        text: this.$t('base.id'),
        value: 'id',
        align: 'right',
        width: '50px'
      },
      {
        text: this.$t('user.username'),
        value: 'username'
      },
      {
        text: this.$t('user.name') + " & " + this.$t('user.surname'),
        value: 'name'
      },
      {
        text: this.$t('user.phone'),
        value: 'phone'
      },
        {
          text: this.$t('user.team'),
          value: 'team'
        },
        {
          text: this.$t('user.role'),
          value: 'team'
      },
      {
        text: this.$t('agency.agency'),
        value: 'agency_id'
      },
      {
        text: this.$t('user.email'),
        value: 'email'
      },
      {
        text: this.$t('user.created-at'),
        value: 'created_at'
      }
      ],
    }
  },
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    users() {
      return this.$store.state.users
    }
  },
  watch: {
    createDialog(val) {
      if (val) {
        this.$store.dispatch("loadTeams")
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    getAgencyName(id){
      let agency = this.agencies.find(a =>a.id == id)
      return agency ? agency.name : ""
    },
    getTeamName(id) {
      let team = this.$store.state.teams.find(a => a.id == id)
      return team ? team.name : ""
    },
    deleteUser(id){
      this.$http.delete(`user/${id}`)
        .then(() => {
          this.$store.commit('setUsers', this.users.filter(user => user.id != id))
          Messenger.emitSuccess("Ok")
        })
        .catch(() => Messenger.emitError("Error"))
    },
    load() {
      this.loading = true
      let users = this.$store.dispatch("loadUsers")
      let agencies = this.$http.get('agencies')

      Promise.all([users,agencies]).then(data => {
        this.agencies = data[1].data
        this.loading = false
      })
    },
    userCreated() {
      this.createDialog = false
      this.load()
    }
  },
}
</script>

<style scoped>
th {
  text-transform: capitalize;
}

.btn-user-action {
  width: 40%;
  float: left;
  margin-left: 5px;
}
</style>
